// Connexion par code personnel (D-010) — logique pure, partagée entre les
// fonctions serveur (Deno) et l'app (navigateur). Aucune dépendance : seulement
// les API Web (crypto.getRandomValues, crypto.subtle, TextEncoder).

/** Domaine des adresses synthétiques : ces comptes ne reçoivent jamais d'e-mail. */
export const CODE_EMAIL_DOMAIN = 'code.arceau.app';

const HANDLE_RE = /^[a-z0-9][a-z0-9-]{2,30}$/;   // même règle que people.login_handle
const CODE_RE = /^\d{6}$/;

/** « Kenza-Léa » → « kenza-lea » ; jamais vide, 20 caractères au plus. */
export function slugify(firstName: string): string {
  const s = firstName
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
    .slice(0, 20).replace(/-+$/, '');
  return s || 'joueur';
}

/** Entier uniforme dans [0, n) — tirage sans biais (rejet). */
function randomBelow(n: number): number {
  const max = Math.floor(0x100000000 / n) * n;
  const buf = new Uint32Array(1);
  for (;;) {
    crypto.getRandomValues(buf);
    if (buf[0]! < max) return buf[0]! % n;
  }
}

/** Identifiant de connexion : prénom + 4 chiffres, ex. « kenza-4821 ». */
export function makeHandle(firstName: string): string {
  return `${slugify(firstName)}-${String(randomBelow(10000)).padStart(4, '0')}`;
}

/** Code à 6 chiffres. */
export function makeCode(): string {
  return String(randomBelow(1000000)).padStart(6, '0');
}

/** Ce que tape l'utilisateur → identifiant normalisé (espaces, majuscules). */
export function normalizeHandle(input: string): string {
  return input.trim().toLowerCase().replace(/\s+/g, '');
}

export const isValidHandle = (h: string): boolean => HANDLE_RE.test(h);
export const isValidCode = (c: string): boolean => CODE_RE.test(c);

export const syntheticEmail = (handle: string): string => `${handle}@${CODE_EMAIL_DOMAIN}`;

/**
 * Mot de passe du compte = HMAC-SHA256(secret serveur, identifiant + code).
 * Sans le secret, essayer des codes directement auprès du service
 * d'authentification ne mène à rien.
 */
export async function derivePassword(pepper: string, handle: string, code: string): Promise<string> {
  if (pepper.length < 32) throw new Error('CODE_PEPPER trop court (32 caractères minimum)');
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey('raw', enc.encode(pepper), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
  const mac = new Uint8Array(await crypto.subtle.sign('HMAC', key, enc.encode(`v1:${handle}:${code}`)));
  let bin = '';
  for (const b of mac) bin += String.fromCharCode(b);
  return 'v1.' + btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
